/**
 * autoplayOverlayHydration
 * ------------------------
 * Helper de hidratação dos campos de geometria do autoplay overlay vindos do
 * backend (`autoplayPositionXPercent`, `autoplayPositionYPercent`,
 * `autoplayWidthPercent`, `autoplayHeightPercent`).
 *
 * Fica FORA de `autoplayOverlayGeometry.ts` de propósito: aquele arquivo é
 * espelhado inline em `e-player-js/js/runner.js` e precisa ficar em sync. Este
 * aqui é exclusivo do front — o player já trata os mesmos campos corretamente
 * com `typeof === "number"`.
 */

/**
 * Converte um valor do backend em número percentual, ou NaN quando não há valor.
 *
 * O `Number()` cru não serve: `Number(null) === 0` e `Number.isFinite(0)` é
 * `true`, então um vídeo que nunca teve o overlay reposicionado (coluna `null`,
 * o caso da maioria) era hidratado como `{ xPercent: 0, yPercent: 0 }` e
 * `widthPercent: 0`. Depois do clamp isso vira x=11% / y=10% / width=18% no
 * editor, enquanto o player mantém o overlay centralizado — divergência
 * editor↔player.
 *
 * `Number()` continua sendo usado para os valores presentes porque o Sequelize
 * pode devolver FLOAT/DECIMAL como string dependendo do driver MySQL.
 */
export function toPercentOrNaN(value: unknown): number {
  if (value === null || value === undefined || value === '') return NaN;
  return Number(value);
}
